import { PostsVirais, SocialMedia } from '@/model';
import {
  GetMediaSocialMediaAddressResponse,
  GetMediaSocialMediaResponse,
  GetPostsViraiItemResponse,
  GetPostsViraisByIdResponse,
  GetPostsViraisResponse,
  PostPostsViraisResponse,
  PutMediaSocialMediaResponse,
  PutPostsViraisResponse,
} from '@/services/response/social-media';

export class SocialMediaConverter {
  static toDomainFromGetAddressResponse(response: GetMediaSocialMediaAddressResponse): SocialMedia {
    return {
      feed_instagram: false,
      feed_twitter: false,
      instagram: response.instagram ? { value: response.instagram, enabled: true } : undefined,
      facebook: response.facebook ? { value: response.facebook, enabled: true } : undefined,
      twitter: response.twitter ? { value: response.twitter, enabled: true } : undefined,
      youtube: response.youtube ? { value: response.youtube, enabled: true } : undefined,
      tiktok: response.tiktok ? { value: response.tiktok, enabled: true } : undefined,
      linkedin: response.linkedin ? { value: response.linkedin, enabled: true } : undefined,
      whatsapp: response.whatsapp ? { value: response.whatsapp, enabled: true } : undefined,
    };
  }

  static toDomainFromPutResponse(response: PutMediaSocialMediaResponse): SocialMedia {
    return {
      feed_instagram: response.feed_instagram,
      feed_twitter: response.feed_twitter,
      instagram: response.instagram,
      facebook: response.facebook,
      twitter: response.twitter,
      youtube: response.youtube,
      tiktok: response.tiktok,
      linkedin: response.linkedin,
      whatsapp: response.whatsapp,
    };
  }

  static toDomainFromGetResponse(response: GetMediaSocialMediaResponse): SocialMedia {
    return {
      feed_instagram: response.feed_instagram,
      feed_twitter: response.feed_twitter,
      instagram: response.instagram,
      facebook: response.facebook,
      twitter: response.twitter,
      youtube: response.youtube,
      tiktok: response.tiktok,
      linkedin: response.linkedin,
      whatsapp: response.whatsapp,
    };
  }

  static toDomainFromGetPostsViraiItemResponse(item: GetPostsViraiItemResponse): PostsVirais {
    return {
      uuid: item.uuid,
      enabled: item.enabled,
      urls: item.urls,
      created_at: item.created_at,
      updated_at: item.updated_at,
      team_uuid: item.team_uuid,
      team_name: item.team_name,
      team_image: item.team_image,
    };
  }

  static toDomainFromGetPostsViraisResponse(response: GetPostsViraisResponse): PostsVirais[] {
    return response.data.map(this.toDomainFromGetPostsViraiItemResponse);
  }

  static toDomainFromGetPostsViraisByIdResponse(response: GetPostsViraisByIdResponse): PostsVirais {
    return {
      uuid: response.uuid,
      enabled: response.enabled,
      urls: response.urls,
      created_at: response.created_at,
      updated_at: response.updated_at,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
    };
  }

  static toDomainFromPostPostsViraisResponse(response: PostPostsViraisResponse): Partial<PostsVirais> {
    return {
      uuid: response.uuid,
      enabled: response.enabled,
      team_uuid: response.team_uuid,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutPostsViraisResponse(response: PutPostsViraisResponse): Partial<PostsVirais> {
    return {
      uuid: response.uuid,
      enabled: response.enabled,
      team_uuid: response.team_uuid,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
